export default "__VITE_ASSET__DFWFx1I0__"